import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.string.link.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "indexProList",
    style: "background-color: ".concat(_vm.data.bgColor, ";")
  }, [_c("div", {
    staticClass: "anchorPointProItem",
    attrs: {
      id: "PRO_" + _vm.id,
      name: _vm.id
    }
  }, [_vm.data.titles[_vm.defaultLangId] ? _c("div", {
    staticClass: "proTitle",
    style: "color: ".concat(_vm.data.titleColor, "; fontSize: ").concat(_vm.data.titleFontSize + "px", "; padding-top: ").concat(_vm.data.titlePaddingTop || 0, "px; padding-bottom: ").concat(_vm.data.titlePadingBottom || 0, "px")
  }, [_vm._v(" " + _vm._s(_vm.data.titles[_vm.defaultLangId]) + " ")]) : _vm._e(), _vm.moduleData && _vm.moduleData.length > 0 ? _c("div", {
    staticClass: "banner_bg",
    style: {
      padding: "0px " + (_vm.data.mHorizontalPadding || 0) + "px"
    }
  }, _vm._l(_vm.moduleData, function (item, index) {
    return _c("div", {
      key: index,
      staticClass: "bg_wrapper",
      style: {
        marginBottom: (_vm.data.mBannerVerticalSpace || 0) + "px"
      }
    }, _vm._l(item, function (item2, i2) {
      return _c("div", {
        key: i2,
        staticClass: "div_img_bg",
        style: {
          width: item2.outWidth,
          height: item2.height,
          margin: "0 ".concat(item2.padding)
        },
        attrs: {
          "data-index": i2
        }
      }, [_c("div", {
        staticClass: "div_content_bg"
      }, [_c("YYImage", {
        staticClass: "div_banner",
        style: item.style,
        attrs: {
          fit: "cover",
          lazy: false,
          src: _vm.imgHost + item2.imgpath
        },
        on: {
          click: function click($event) {
            return _vm.goToPage(item.link);
          }
        }
      }), item.link ? _c("a", {
        staticStyle: {
          display: "none"
        }
      }) : _vm._e()], 1), item.link ? _c("a", {
        staticStyle: {
          display: "none"
        }
      }) : _vm._e()]);
    }), 0);
  }), 0) : _vm._e(), _vm.data.productList && _vm.data.productList.length ? _c("waterfall", {
    ref: "waterfall",
    staticClass: "home_waterfall",
    class: {
      home_waterfall_top: _vm.moduleData.length > 0
    },
    attrs: {
      List: _vm.productList,
      showEnd: false
    }
  }) : _vm._e()], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };